import { SupportedLanguage } from "../../config/languages";
import { buildPageUrl } from "../../helpers/urlHelpers";
import classNames from "classnames/bind";
import NextLink from "next/link";
import { AnchorHTMLAttributes, ReactNode } from "react";
import styles from "./Link.module.css";

const cx = classNames.bind(styles);

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  openInNewTab?: boolean;
  className?: string;
  locale: SupportedLanguage;
}

export const Link = ({
  href,
  children,
  openInNewTab = false,
  className,
  locale,
  ...props
}: LinkProps) => {
  const isExternal = href.startsWith("http") || href.startsWith("//");
  const url = isExternal ? href : buildPageUrl(href, locale);

  if (openInNewTab) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={cx("link", className)}
        {...props}
      >
        {children}
      </a>
    );
  }

  if (isExternal) {
    return (
      <a href={url} className={cx("link", className)} {...props}>
        {children}
      </a>
    );
  }

  return (
    <NextLink href={url} className={cx("link", className)} {...props}>
      {children}
    </NextLink>
  );
};
